export default __webpack_public_path__ + "static/media/OCC-LOGO-L.678da779.png";